module.exports = "https://static.wanderu.com/static/media/shuttle-grey.8673b80a.svg";